import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import getAuthToken from '../../utils/authToken';
import { STATUS } from '../../utils/status';
import { constants } from '../../utils/constants';

interface Document {
  url: string;
}

interface UploadState {
  file: string;
  fileUploadStatus: string;
  fileUploadError: string;
  documents: { [configId: string]: Document };
}

const initialState: UploadState = {
  file: '',
  fileUploadStatus: STATUS.NOT_STARTED,
  fileUploadError: '',
  documents: {}
};

interface LatexPayload {
  latex: string;
  alloc_id: string;
  config_id: string;
}

export const latexAction = createAsyncThunk(
  "process/latex",
  async (payload: LatexPayload) => {
    const token = getAuthToken();
    const response = await fetch(`${constants.API_BASE_URL}process/latex/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { ...data, config_id: payload.config_id };
  }
);

const latexCodeSlice = createSlice({
  name: 'latex',
  initialState,
  reducers: {
    setfileUploadStatus: (state, action) => {
      state.fileUploadStatus = action.payload;
    },
    clearLatexState: (state) => {
      state.file = '';
      state.fileUploadStatus = STATUS.NOT_STARTED;
      state.fileUploadError = '';
      state.documents = {};
    }
  },
  extraReducers: (builder) => {
    builder.addCase(latexAction.pending, (state) => {
      state.fileUploadStatus = STATUS.PENDING;
    });

    builder.addCase(latexAction.fulfilled, (state, action) => {
      const { config_id, url } = action.payload;
      state.documents[config_id] = { url };
      state.fileUploadStatus = STATUS.SUCESS;
    });

    builder.addCase(latexAction.rejected, (state, action) => {
      state.fileUploadError = action.error.message ?? "Unknown error";
      state.fileUploadStatus = STATUS.FAILED;
    });
  }
});

export const { setfileUploadStatus, clearLatexState } = latexCodeSlice.actions;

export default latexCodeSlice.reducer;
